import CryptoJS from "crypto-js";
import { useSelector } from "react-redux";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Avatar,
  Chip,
  Tabs,
  Tab,
  TextField,
  Button,
  Divider,
  IconButton,
  Snackbar,
  CircularProgress,
  Pagination,
  Step,
  Stepper,
  StepLabel,
  Container,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Modal,
  Skeleton,
  Tooltip,
} from "@mui/material";
import { useEffect, useState } from "react";
import PreviewFileItem from "../../../Utilities/PreviewFileItem";
import DefaultUniversity from "../../../../Assets/img/default-university-logo.jpg";
import { useProfileContext } from "../../../ProfileDetailContext";
import * as pdfjsLib from "pdfjs-dist/webpack";
import Candidate_coverPhoto from "../../../../Assets/Candidate_coverPhoto.png"

const CandidateDetails = ({ professionalInfo, applicantId }) => {
  const [isProfileView, setIsProfileView] = useState(false);
  const [isResumeView, setIsResumeView] = useState(true);
  const [isLoadingProfile, setIsLoadingProfile] = useState(false);
  const [isLoadingResume, setIsLoadingResume] = useState(false);
  const { openDocumentViewer } = useProfileContext();
  const [resumeImageData, setResumeImageData] = useState(null);
  // const professionalInfo = useSelector((state) => state?.ProfileArray?.otherProfessionalInfo);
  const [showFullAbout, setShowFullAbout] = useState(false);
  // console.log("resumeImageData", resumeImageData);

  const personalDetails = professionalInfo?.personalInfo;
  const certificates = professionalInfo?.certificates;
  const awards = professionalInfo?.awards;
  const education = professionalInfo?.education;
  const experience = professionalInfo?.experiences;
  const projects = professionalInfo?.projects;
  const resume = professionalInfo?.resume?.[0];
  const resumeUrl = resume?.document_url;
  const videoResume = professionalInfo?.video_resume?.[0]?.document_url;
  const service = professionalInfo?.services?.[0];
  const skills = professionalInfo?.skills;
  const profilePic = professionalInfo?.profile_pic;
  const userRefId = professionalInfo?.personalInfo?.user_ref_id;
  const accessToken = professionalInfo?.accessToken;

  // console.log("resume", resume);

  // console.log("professionalInfo", projects);

  useEffect(() => {
    if (resumeUrl) {
      convertPdfToImage(resumeUrl);
    }
  }, [resumeUrl]); // Add resumeUrl as dependency

  const handleViewResume = () => {
    setIsProfileView(false);
    // openDocumentViewer(file)
    setIsResumeView(!false);
  };

  const handleViewProfile = () => {
    setIsProfileView(true);
    setIsResumeView(false);
  };

  const encryptedId = encodeURIComponent(
    CryptoJS.AES.encrypt(
      userRefId?.toString(),
      "UserDetailsSecretKey"
    ).toString()
  );

  const handleViewPortfolio = async () => {
  window.open(
    `/portfolio?encryptedId=${encryptedId}&link=${accessToken}`,
    "_blank"
  );
};

  const handleResumeDownload = async (resumeUrl) => {
    if (resumeUrl) {
      try {
        // Fetch the PDF data
        const response = await fetch(resumeUrl);
        const blob = await response.blob(); // Get the blob data from response
        const url = URL.createObjectURL(blob); // Create a blob URL

        // Set filename ensuring .pdf extension
        const fileName = resume.document_name?.endsWith(".pdf")
          ? resume.document_name
          : `${resume.document_name || "resume"}.pdf`;

        // Create a temporary anchor element to trigger download
        const link = document.createElement("a");
        link.href = url; // Set the URL to the blob URL
        link.download = fileName; // Set the download attribute
        document.body.appendChild(link);
        link.click(); // Trigger the download
        document.body.removeChild(link); // Clean up
      } catch (error) {
        console.error("Error downloading the resume:", error);
        // setSnackbarOpen(true); // Show the Snackbar if there is an error
      }
    } else {
      //   setSnackbarOpen(true); // Show the Snackbar if no resume found
    }
  };

  const ProfileLoader = () => (
    <Box sx={{ p: 2 }}>
      <Skeleton variant="rectangular" height={200} />
      <Skeleton
        variant="circular"
        width={100}
        height={100}
        sx={{ mt: -5, ml: 2 }}
      />
      <Box sx={{ p: 2 }}>
        <Skeleton variant="text" width="60%" height={40} />
        <Skeleton variant="text" width="40%" />
        <Skeleton variant="text" width="80%" />
      </Box>
    </Box>
  );

  const convertPdfToImage = async (url) => {
    try {
      setIsLoadingResume(true);
      const loadingTask = pdfjsLib.getDocument(url);
      const pdf = await loadingTask.promise;
      const numPages = pdf.numPages;
      const imageUrls = [];

      for (let pageNumber = 1; pageNumber <= numPages; pageNumber++) {
        const page = await pdf.getPage(pageNumber);
        const viewport = page.getViewport({ scale: 2.0 });
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        canvas.width = viewport.width;
        canvas.height = viewport.height;

        await page.render({ canvasContext: context, viewport }).promise;
        imageUrls.push(canvas.toDataURL("image/png"));
      }

      setResumeImageData(imageUrls);
    } catch (error) {
      console.error("Error converting PDF to image:", error);
    } finally {
      setIsLoadingResume(false);
    }
  };

  return (
    <Box
      sx={{
        width: "30%",
        height: "100vh",
        overflowY: "scroll",
        scrollbarWidth: "none",
        padding: 0.5,
      }}
    >
      <Box sx={{ flexGrow: 1, padding: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Button variant="contained" fullWidth onClick={handleViewResume}>
              Resume
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button variant="contained" fullWidth onClick={handleViewProfile}>
              Profile
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button variant="contained" fullWidth onClick={handleViewPortfolio}>
              Portfolio
            </Button>
          </Grid>
        </Grid>
      </Box>

      <Box
        sx={{
          width: "100%",
          padding: 1,
          borderRadius: 3,
          boxShadow: 3,
          overflow: "hidden",
          backgroundColor: "#fff",
          margin: "auto",
          position: "relative",
        }}
      >
        {isProfileView &&
          (isLoadingProfile ? (
            <ProfileLoader />
          ) : (
            <Box
              sx={{
                backgroundColor: "#f4f4f4",
                maxHeight: "750px",
                overflowY: "auto",
                scrollbarWidth: "none",
              }}
            >
              {/* Cover Section */}
              <Box
                sx={{
                  position: "relative",
                  height: 200,
                  backgroundImage: `url('${
                    professionalInfo?.user_cover_url || Candidate_coverPhoto
                  }')`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                {/* Profile Picture */}
                <Avatar
                  src={profilePic}
                  alt={`${personalDetails?.first_name} ${personalDetails?.last_name}`}
                  sx={{
                    width: 100,
                    height: 100,
                    position: "absolute",
                    bottom: -40,
                    left: 20,
                    border: "4px solid white",
                  }}
                />
              </Box>

              {/* Profile Content */}
              <Box
                p={3}
                // mt={6}
                pt={8}
                sx={{ backgroundColor: "white", borderRadius: 2 }}
              >
                {/* Name and Title */}
                <Typography variant="h5" fontWeight="bold">
                  {personalDetails?.first_name} {personalDetails?.last_name}
                </Typography>
                <Typography variant="body1" color="textSecondary" mb={1}>
                  {personalDetails?.designation || "Frontend Developer"} |{" "}
                </Typography>

                {/* Contact Information */}
                {/* <Box display="flex" gap={2} flexWrap="wrap" mb={2}> */}
                {/* {professionalInfo?.companyEmail ? (
                    <Typography
                      variant="body2"
                      component="a"
                      href={`mailto:${professionalInfo.companyEmail}`}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        color: "inherit",
                        textDecoration: "none",
                        cursor: "pointer",
                      }}
                    >
                      <Email fontSize="small" sx={{ mr: 1 }} />
                      {professionalInfo.companyEmail}
                    </Typography>
                  ) : (
                    <Typography
                      variant="body2"
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      <Email fontSize="small" sx={{ mr: 1 }} />
                      No Email Provided
                    </Typography>
                  )} */}

                {/* <Typography
                    variant="body2"
                    component="a"
                    href={
                      professionalInfo?.companyPhone
                        ? `tel:${professionalInfo?.companyPhone}`
                        : undefined
                    }
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      color: "inherit",
                      textDecoration: professionalInfo?.companyPhone
                        ? "none"
                        : "none",
                      pointerEvents: professionalInfo?.companyPhone
                        ? "auto"
                        : "none",
                    }}
                  > */}
                {/* {professionalInfo?.companyPhone ? (
                      <Phone fontSize="small" sx={{ mr: 1 }} />
                    ) : (
                      ""
                    )}
                    {professionalInfo?.companyPhone || "No Contact Number"}
                  </Typography> */}
                {/* <Typography variant="body2">
                    {professionalInfo?.companyWebsite ? (
                      <Language fontSize="small" sx={{ mr: 1 }} />
                    ) : (
                      ""
                    )}
                    <a
                      href={professionalInfo?.companyWebsite}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {professionalInfo?.companyWebsite}
                    </a>
                  </Typography> */}
                {/* </Box> */}

                {/* About Me */}
                {personalDetails?.about_me &&
                  personalDetails?.about_me.trim() !== "" && (
                    <>
                      <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                        About Me
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        mb={2}
                        sx={{
                          whiteSpace: showFullAbout ? "pre-line" : "normal",
                          display: "-webkit-box",
                          WebkitLineClamp: showFullAbout ? "unset" : 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          transition: "all 0.3s ease",
                        }}
                      >
                        {personalDetails?.about_me}
                      </Typography>
                      {personalDetails?.about_me.length > 100 && (
                        <Box display="flex" justifyContent="flex-end">
                          <Button
                            onClick={() => setShowFullAbout(!showFullAbout)}
                            sx={{
                              padding: 0,
                              minWidth: "auto",
                              textTransform: "none",
                              color: "primary.main",
                              fontSize: "small",
                            }}
                          >
                            {showFullAbout ? "Show Less" : "Show More"}
                          </Button>
                        </Box>
                      )}
                    </>
                  )}

                <Divider sx={{ my: 2 }} />

                {/* Professional Skills */}
                {skills?.professional_skills?.skills?.length > 0 && (
                  <>
                    <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                      Professional Skills
                    </Typography>
                    <Box display="flex" gap={1} flexWrap="wrap">
                      {skills?.professional_skills?.skills?.map(
                        (skill, index) => (
                          <Chip
                            key={index}
                            label={skill}
                            color="primary"
                            size="small"
                          />
                        )
                      )}
                    </Box>

                    <Divider sx={{ my: 2 }} />
                  </>
                )}
                {/* Tools */}
                {skills?.professional_tools?.skills?.length > 0 && (
                  <>
                    <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                      Tools
                    </Typography>
                    <Box display="flex" gap={1} flexWrap="wrap">
                      {skills?.professional_tools?.skills?.map(
                        (tool, index) => (
                          <Chip
                            key={index}
                            label={tool}
                            color="secondary"
                            size="small"
                          />
                        )
                      )}
                    </Box>

                    <Divider sx={{ my: 2 }} />
                  </>
                )}

                {/* Soft Skills */}
                {skills?.soft_skills?.skills?.length > 0 && (
                  <>
                    <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                      Soft Skills
                    </Typography>
                    <Box display="flex" gap={1} flexWrap="wrap">
                      {skills?.soft_skills?.skills?.map((skill, index) => (
                        <Chip key={index} label={skill} size="small" />
                      ))}
                    </Box>

                    <Divider sx={{ my: 2 }} />
                  </>
                )}

                {experience?.length > 0 && (
                  <>
                    <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                      Work Experience
                    </Typography>

                    <Box>
                      {experience?.map((experience, index) => (
                        <Card
                          key={index}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            p: 2,
                            mb: 2,
                          }}
                        >
                          {/* Company Logo */}
                          <Box
                            component="img"
                            src={experience?.company_logo}
                            alt={experience?.company_name}
                            sx={{
                              width: 80,
                              height: 50,
                              objectFit: "contain",
                              mr: 2,
                            }}
                          />

                          {/* Experience Details */}
                          <CardContent sx={{ flex: 1, p: 1 }}>
                            <Grid container spacing={0.5}>
                              <Grid item xs={12}>
                                <Typography variant="body1" fontWeight="bold">
                                  {experience?.role_title}
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  {experience?.company_name}
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  {experience?.start_month}{" "}
                                  {experience?.start_year} -{" "}
                                  {experience?.is_currently_working
                                    ? "Present"
                                    : `${experience?.end_month} ${experience?.end_year}`}
                                </Typography>
                              </Grid>
                              {experience?.location && (
                                <Grid item xs={12}>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    {experience?.location} (
                                    {experience?.location_type})
                                  </Typography>
                                </Grid>
                              )}
                              {experience?.details && (
                                <Grid item xs={12}>
                                  <Typography variant="caption">
                                    {experience?.details}
                                  </Typography>
                                </Grid>
                              )}
                            </Grid>
                          </CardContent>
                        </Card>
                      ))}
                    </Box>

                    <Divider sx={{ my: 2 }} />
                  </>
                )}
                {certificates?.length > 0 && (
                  <>
                    <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                      Certificates
                    </Typography>

                    <Box>
                      {certificates?.map((certificate, index) => (
                        <Card
                          key={index}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            p: 2,
                            mb: 2,
                            boxShadow: 2,
                          }}
                        >
                          {/* Certificate Logo */}
                          <Box
                            component="img"
                            src={certificate?.certificate_logo}
                            alt={certificate?.organisation_name}
                            sx={{
                              width: 80,
                              height: 50,
                              objectFit: "contain",
                              mr: 2,
                            }}
                          />

                          {/* Certificate Details */}
                          <CardContent sx={{ flex: 1, p: 1 }}>
                            <Grid container spacing={0.5}>
                              <Grid item xs={12}>
                                <Typography variant="body1" fontWeight="bold">
                                  {certificate?.course_name}
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  {certificate?.organisation_name}
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  {certificate?.certifiMonth}{" "}
                                  {certificate?.certifiYear}
                                </Typography>
                              </Grid>
                              {certificate?.certifiDetails && (
                                <Grid item xs={12}>
                                  <Typography variant="caption">
                                    {certificate?.certifiDetails}
                                  </Typography>
                                </Grid>
                              )}
                              {certificate?.certificate_doc && (
                                <Grid item xs={12}>
                                  <PreviewFileItem
                                    file={certificate?.certificate_doc}
                                    fontColor="#00000099"
                                  />
                                </Grid>
                              )}
                            </Grid>
                          </CardContent>
                        </Card>
                      ))}
                    </Box>
                    <Divider sx={{ my: 2 }} />
                  </>
                )}

                {projects?.length > 0 && (
                  <>
                    <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                      Projects
                    </Typography>

                    <Box>
                      {projects?.map((project, index) => (
                        <Card key={index} sx={{ p: 2, mb: 2, boxShadow: 2 }}>
                          <CardContent sx={{ p: 1 }}>
                            <Grid container spacing={0.5}>
                              {/* Project Name */}
                              <Grid item xs={12}>
                                <Typography variant="body1" fontWeight="bold">
                                  {project?.project_name || ""}
                                </Typography>
                              </Grid>

                              {/* Project Description */}
                              <Grid item xs={12}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  {project?.projectDescription || ""}
                                </Typography>
                              </Grid>

                              {/* Project Duration */}
                              <Grid item xs={12}>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  {project?.startMonth &&
                                  project?.startYear &&
                                  (project?.currentlyWorking ||
                                    (project?.endMonth && project?.endYear))
                                    ? `${project.startMonth} ${
                                        project.startYear
                                      } - ${
                                        project.currentlyWorking
                                          ? "Present"
                                          : `${project.endMonth} ${project.endYear}`
                                      }`
                                    : ""}
                                </Typography>
                              </Grid>

                              {/* Project Link */}
                              {project?.attachments?.length !== 0 && (
                                <>
                                  <div>
                                    <div className="project-profile">
                                      Attachments:
                                    </div>
                                    {project?.attachments
                                      ?.filter(
                                        (attachment) => !attachment.toBeDeleted
                                      )
                                      ?.map((attachment, idx) => (
                                        <div
                                          key={idx}
                                          // className="profile-project-display my-3"
                                          style={{
                                            // border: "1px solid red",
                                            width: "100%",
                                            padding: "5px",
                                          }}
                                        >
                                          {typeof attachment === "string" ? (
                                            <a href={attachment?.document_url}>
                                              <div className="design-lighter-textNew">
                                                {attachment}
                                              </div>
                                            </a>
                                          ) : (
                                            <div>
                                              <PreviewFileItem
                                                file={attachment}
                                                fontColor="#00000099"
                                              />
                                            </div>
                                          )}
                                        </div>
                                      ))}
                                  </div>
                                </>
                              )}
                            </Grid>
                          </CardContent>
                        </Card>
                      ))}
                    </Box>
                    <Divider sx={{ my: 2 }} />
                  </>
                )}
                {education?.length > 0 && (
                  <>
                    <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                      Education
                    </Typography>

                    <Box>
                      {education?.map((education, index) => (
                        <Card
                          key={index}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            p: 2,
                            mb: 2,
                            boxShadow: 2,
                          }}
                        >
                          {/* Institution Logo */}
                          <Box
                            component="img"
                            src={
                              education?.instituteByName?.logo || education?.logo_link
                                ? education?.instituteByName?.logo || education?.logo_link
                                : DefaultUniversity
                            }
                            alt={education?.institute_name}
                            sx={{
                              width: 80,
                              height: 50,
                              objectFit: "contain",
                              mr: 2,
                            }}
                          />

                          {/* Education Details */}
                          <CardContent sx={{ flex: 1, p: 1 }}>
                            <Grid container spacing={0.5}>
                              <Grid item xs={12}>
                                <Typography variant="body1" fontWeight="bold">
                                  {education?.degree}
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  {education?.field_of_study}
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  {education?.institute_name}
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  {education?.board}
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  {education?.start_year} -{" "}
                                  {education?.is_pursuing
                                    ? "Present"
                                    : education?.end_year}
                                </Typography>
                              </Grid>
                              {education?.percentage && (
                                <Grid item xs={12}>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    Percentage: {education?.percentage}
                                  </Typography>
                                </Grid>
                              )}
                            </Grid>
                          </CardContent>
                        </Card>
                      ))}
                    </Box>
                    <Divider sx={{ my: 2 }} />
                  </>
                )}

                <Box sx={{ p: 2 }}>
                  {/* <Typography
                      variant="h6"
                      gutterBottom
                      sx={{ fontSize: "14px" }}
                    >
                      Scoring Overview
                    </Typography>
                    <ReactApexChart
                      options={options}
                      series={series}
                      type="bar"
                      height={200}
                    />

                    <Container width="100%" sx={{ mt: 4 }}>
                      <Paper
                        sx={{
                          p: 1,
                          borderRadius: 2,
                          boxShadow: 3,
                          backgroundColor: "white",
                          width: "100%",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <ReactApexChart
                            options={options1}
                            series={options1?.series || []} // Ensure series is always defined as an array
                            type="radar"
                            height={350}
                          />
                        </Box>
                      </Paper>
                    </Container> */}
                </Box>
              </Box>
            </Box>
          ))}

        {isResumeView && (
          <>
            <div
              style={{
                border: "1px solid #ccc",
                height: "500px",
                overflowY: "scroll",
                scrollbarWidth: "none",
              }}
            >
              {isResumeView && (
                <>
                  <div
                    style={{
                      border: "1px solid #ccc",
                      height: "500px",
                      overflowY: "scroll",
                      scrollbarWidth: "none",
                    }}
                  >
                    {isLoadingResume ? (
                      <Box
                        sx={{ display: "flex", justifyContent: "center", p: 3 }}
                      >
                        <CircularProgress />
                      </Box>
                    ) : (
                      <div
                        style={{ border: "1px solid #ccc", height: "500px" }}
                      >
                        {!resume ? (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "100%",
                            }}
                          >
                            <p>No Resume Found</p>
                          </Box>
                        ) : resumeImageData ? (
                          <div>
                            {resumeImageData.map((document_url, index) => (
                              <a
                                key={index}
                                className="pointer"
                                onClick={() => openDocumentViewer(resume)}
                                style={{
                                  display: "block",
                                  marginBottom: "20px",
                                }}
                              >
                                <img
                                  src={document_url}
                                  alt={`Page ${index + 1}`}
                                  style={{ width: "100%" }}
                                />
                              </a>
                            ))}
                          </div>
                        ) : (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "100%",
                            }}
                          >
                            <p>Failed to load resume</p>
                          </Box>
                        )}
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </Box>
      {isResumeView ? (
        <Box sx={{ width: "60%", margin: "auto", marginTop: "5%" }}>
          <Button
            variant="contained"
            fullWidth
            onClick={() => handleResumeDownload(resume?.document_url)}
          >
            Download
          </Button>
        </Box>
      ) : (
        ""
      )}
    </Box>
  );
};

export default CandidateDetails;
